import { Button, FlexboxGrid } from 'rsuite';

const SkillsModeButton = ({
    editMode,
    skillsExpanded,
    showExpandControls,
    onClick,
}: {
    editMode: boolean;
    skillsExpanded: boolean;
    showExpandControls: boolean;
    onClick: () => void;
}) => (
    <FlexboxGrid.Item>
        {editMode && (skillsExpanded || !showExpandControls) ? (
            <Button onClick={() => onClick()}>Close</Button>
        ) : skillsExpanded || !showExpandControls ? (
            <Button onClick={() => onClick()}>Edit</Button>
        ) : (
            <div style={{ width: 50 }}></div>
        )}
    </FlexboxGrid.Item>
);

export default SkillsModeButton;
